import { render, staticRenderFns } from "./422.vue?vue&type=template&id=4f7e8190&scoped=true&lang=pug&"
import script from "./422.vue?vue&type=script&lang=js&"
export * from "./422.vue?vue&type=script&lang=js&"
import style0 from "./422.vue?vue&type=style&index=0&id=4f7e8190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e8190",
  null
  
)

export default component.exports